import { render, staticRenderFns } from "./AdvisorHome.vue?vue&type=template&id=19c69a96&"
import script from "./AdvisorHome.vue?vue&type=script&lang=ts&"
export * from "./AdvisorHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports